import React, { useContext, useEffect, useRef } from "react";
import { useActionReducer } from "../../../context/ActionProvider";
import { useAnalytics } from "../../../providers/AnalyticsProvider";
import { AnalyticsEventTypes, sendEvent } from "../../../functional/analyticsUtils";
import { WebActionType } from "../../../schemas/Actions";
import styled from "styled-components";
import { MediaType } from "../../Media";
import { HubSdkContext } from "@riotgames/pubhub-sdk";
function getActionAnchorProps(action) {
    if (action?.type === WebActionType.Weblink) {
        return {
            href: action.payload.url,
            target: action.payload.isExternal ? "_blank" : undefined,
        };
    }
    else if (action?.type === WebActionType.YoutubeVideo) {
        return {
            href: action.payload.url,
        };
    }
    else if (action?.type === WebActionType.MediaViewer && action.payload.media.type === MediaType.IMAGE) {
        return {
            href: action.payload.media.url,
        };
    }
    else
        return {
            href: "javascript: void(0)",
        };
}
const StyledActionHandler = styled.a(({ hasAction }) => hasAction ? "cursor: pointer;" : undefined);
export const ActionHandler = ({ action, contentAnalytics, children, onClick: onClickParam, disabled, ...props }) => {
    const { dispatchAction } = useActionReducer();
    const { page, blade, uiLocation } = useAnalytics();
    const anchorRef = useRef(null);
    const anchorProps = getActionAnchorProps(action);
    const sdk = useContext(HubSdkContext);
    const handleContentClick = React.useCallback(async (e) => {
        if (disabled) {
            e?.preventDefault();
            return;
        }
        if (action) {
            const unhandledAction = await sdk?.executeAction(action);
            if (!sdk || unhandledAction) {
                dispatchAction(action);
            }
        }
        if (onClickParam && e) {
            onClickParam?.(e);
        }
        sendEvent(AnalyticsEventTypes.content_engagement, {
            page,
            blade,
            uiLocation,
            content: contentAnalytics,
        });
        if (action?.type === WebActionType.YoutubeVideo ||
            action?.type === WebActionType.ImageViewer ||
            action?.type === WebActionType.MediaViewer) {
            sendEvent(AnalyticsEventTypes.modal_opened, {
                page,
                blade,
                uiLocation,
                content: contentAnalytics,
                modalType: "lightbox",
            });
        }
        e?.preventDefault();
    }, [action, onClickParam, page, blade, uiLocation, contentAnalytics, sdk, dispatchAction, disabled]);
    useEffect(() => {
        const handleKeyUp = (e) => {
            const parentDataFocused = anchorRef.current?.parentElement?.getAttribute("data-focused") ||
                anchorRef.current?.parentElement?.parentElement?.getAttribute("data-focused");
            const inFocus = document.activeElement !== document.body &&
                document.activeElement?.contains(anchorRef.current) &&
                (!parentDataFocused || parentDataFocused === "true");
            if (!inFocus) {
                return;
            }
            if (e.key === "Enter") {
                e.preventDefault();
                handleContentClick();
            }
        };
        document.addEventListener("keyup", handleKeyUp);
        return () => {
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, [handleContentClick]);
    return (React.createElement(StyledActionHandler, { role: "button", ref: anchorRef, onClick: handleContentClick, "aria-label": contentAnalytics.title, hasAction: Boolean(action || onClickParam), "aria-disabled": disabled || undefined, ...anchorProps, ...props }, children));
};
//# sourceMappingURL=ActionHandler.js.map